import { connect } from 'react-redux';
import MenuView from './index'
import {loadPages} from '../../../actions/Pages'

const mapStateToProps = (state, props) => {  
    return {
	pages: state.pages.list
    }
}

const mapDispatchToProps = (dispatch, state) => {
  
    return {
	loadPages: () => {
	    return dispatch(loadPages());
	}
    }
}

const MenuContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuView);




export default MenuContainer;



// WEBPACK FOOTER //
// ./src/components/Layout/Menu/Container.js